import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, HostListener, Inject, afterNextRender } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryStringService } from '../services/query-string.service';

@Directive({
  selector: '[appInnerHtml]'
})
export class InternalLinkRoutingDirective {
  private queryParams;

  constructor(private router: Router,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private dom: Document,
    private queryStringService: QueryStringService,
    private el: ElementRef) {

    this.queryParams = this.queryStringService.sanitizeParams(this.route.snapshot.queryParams);

    afterNextRender(() => {
      try {
        const existingURLSearchParams = new URLSearchParams(this.dom.location.search);
        let siteQueryParams = Object.fromEntries(existingURLSearchParams.entries());
        siteQueryParams = this.queryStringService.removeBlackListedParams(siteQueryParams);

        const aTags = [...this.el.nativeElement.querySelectorAll('a')];
        const baseURI = document.baseURI.slice(0, document.baseURI.length - 1);
        aTags.forEach(a => {
          const href = a.getAttribute('href');
          if (href.startsWith('tel:') || href.startsWith('mailto:')) {
            return;
          } else {
            // Internal or external links inside the rich text content wont be considered by the PathPreserveQueryLocationStrategy service.
            const urlForRelativePath = href.startsWith('/') ? href : '/' + href;
            const url = new URL(href.startsWith('http') ? href : (baseURI + urlForRelativePath));
            const existingQueryParams = Object.fromEntries(
              url.searchParams.entries()
            );
            const queryParams = { ...existingQueryParams, ...siteQueryParams };
            url.search = Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join("&");
            if (href.startsWith('http')) {
              a.setAttribute('href', url.toString());
            } else {
              url.pathname = href.startsWith('#') ? this.route.snapshot.url.join('/') : url.pathname;
              a.setAttribute('href', url.toString().split(url.origin)[1]);
            }
          }
        });
      } catch (e) {
        console.error("Failed to construct URL from href", e);
      }
    });
  }

  @HostListener('click', ['$event'])
  onClick(e: any) {

    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) {
      return;
    }

    const path = e.composedPath() as Array<any>;
    const firstAnchor = path.find(p => p.tagName?.toLowerCase() === 'a');
    if (firstAnchor && !firstAnchor.hasAttribute('routerlink')) {
      const href = firstAnchor.getAttribute('href');
      const target = firstAnchor.getAttribute('target');

      if (href.startsWith('mailto:') || href.startsWith('tel:')) {
        return;
      } else if (href.startsWith('http') || target == '_blank') {
        const url = href.startsWith('http') ? href : this.dom.baseURI + (href.startsWith('/') ? href.slice(1, href.length) : href);
        window.open(url, "_blank");
        e.preventDefault();
      } else if (href.startsWith('#')) {
        let url = this.router.url;
        url = url.includes("#") ? url.split('#')[0] : url;
        this.router.navigateByUrl(url + href);
        e.preventDefault();
      } else {
        this.router.navigateByUrl(href);
        e.preventDefault();
      }
    }
  }
}
